// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__34ue1","filesListContainer":"PosDisputesFiles_filesListContainer__5S10z","filesButton":"PosDisputesFiles_filesButton__13hMZ"};